import { faCalendarDays } from '@fortawesome/pro-regular-svg-icons';
import { Period } from '@spike/model';
import { DateRangePickerDropdown } from 'components/UI/V3/DateRangePickerDropdown';
import { useTimeZone } from 'hooks';
import { useDateRangeOptions } from 'hooks/useDateRangeOptions';
import useIsMobile from 'hooks/useIsMobile';
import moment from 'moment-timezone';
import { FunctionComponent } from 'react';
import styles from './TasksDatePicker.module.scss';

interface TasksDatePickerProps {
    value: Period;
    className?: string;
    onChange: (period: Period) => void;
}

export const TasksDatePicker: FunctionComponent<TasksDatePickerProps> = ({ value, className, onChange }) => {
    const isMobile = useIsMobile();
    const timeZone = useTimeZone();
    const { todayOption, tomorrowOption, next7DaysOption, thisMonthOption, last30DaysOption, lastMonthOption } =
        useDateRangeOptions();

    const allTimeOption = {
        label: 'All time',
        value: {
            from: moment.tz('2000-01-01', timeZone).startOf('day'),
            to: moment.tz(timeZone).add(2, 'years').endOf('day')
        }
    };

    return (
        <div className={className}>
            <DateRangePickerDropdown
                timeZone={timeZone}
                value={value}
                onChange={period => period && onChange(period)}
                options={[
                    todayOption,
                    tomorrowOption,
                    next7DaysOption,
                    thisMonthOption,
                    last30DaysOption,
                    lastMonthOption,
                    allTimeOption
                ]}
                buttonProps={{
                    variant: 'outlined',
                    size: 'large',
                    leftIcon: faCalendarDays,
                    onlyIcon: isMobile,
                    className: styles.dateButton
                }}
            />
        </div>
    );
};

export default TasksDatePicker;
